<template>
  <div v-if="!abTestId && (showCountLabel || showLabel)" :class="[$style.chip, $style[statusClass]]">
    <span :class="$style.statusCircle"></span>
    <span v-if="showLabel" :class="$style.statusText">{{ statusText }}</span>
    <span v-else>{{ statusCount }}</span>
  </div>

  <div v-else-if="abTestId && (showCountLabel || showLabel)" :class="$style.flex">
    <div :class="[$style.chipLeft, $style[statusClass]]">
      <span :class="$style.abText">AB</span>
    </div>
    <div :class="[$style.chipRight, $style[statusClass]]">
      <span :class="$style.statusText">{{ statusText }}</span>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  status: String,
  abTestId: {
    type: String,
    default: null,
  },
  showLabel: {
    type: Boolean,
    default: true,
  },
  statusCount: {
    type: Number,
    default: 0,
  },
});

const statusClass = computed(() => `status-${props.status.toLowerCase()}`);
const statusText = computed(() => {
  const lowerCaseStatus = props.status.toLowerCase();
  return lowerCaseStatus.charAt(0).toUpperCase() + lowerCaseStatus.slice(1);
});

const showCountLabel = computed(() => !props.showLabel && props.statusCount);
</script>

<style module>
.chipLeft {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 8px 0 0 8px;
  font-size: 12px;
  font-weight: 500;
}

.chipRight {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 0 8px 8px 0;
  font-size: 12px;
  font-weight: 500;
}
.chip {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 500;
}

.statusCircle {
  height: 8px;
  width: 8px;
  border-radius: 50%;
  margin-right: 8px;
}

.statusText {
  color: #333;
  font-size: 1rem;
}

.status-draft,
.status-pending {
  background-color: var(--vd-color-blue-light-9);
}

.status-draft .statusCircle,
.status-draft.chipLeft,
.status-pending .statusCircle,
.status-pending.chipLeft {
  background-color: var(--vd-color-blue-dark-3);
}

.status-published {
  background-color: #f0f9eb;
}

.status-published .statusCircle,
.status-published.chipLeft {
  background-color: #52992e;
}

.status-stopped,
.status-terminating {
  background-color: #e9e9ea;
}

.status-stopped .statusCircle,
.status-stopped.chipLeft,
.status-terminating .statusCircle,
.status-terminating.chipLeft {
  background-color: #313335;
}

.flex {
  display: flex;
}

.abText {
  color: #fff;
  font-size: 1rem;
}
</style>
